var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-other"},[_c('div',{staticClass:"inner-header-other",style:({width: _vm.width + 'px'})},[_c('div',{staticClass:"left-heander-other"},[_c('en-logo'),_vm._v(" "),_c('span',{staticClass:"logo-title"},[_vm._v(_vm._s(_vm.title))])],1),_vm._v(" "),_c('div',{staticClass:"right-heander-other"},[_vm._t("default")],2)])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16d1bd72","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderOther.vue
// module id = null
// module chunks = 